module.exports = __webpack_public_path__ + "static/img/cDR11.92b033bb.png";